module.exports = __webpack_public_path__ + "img/facebook.ad6bd3a0.svg";